import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInput from "../../../components/forms/CommonInput";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInputSenha from "../../../components/forms/CommonInputSenha";
import { handleChange } from "../../../helpers/handleFormChanges.js";
import { AppContext } from "../../../contexts/AppContext";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

function UsuarioModal({
  usuarioModalHook,
  valuesHook,
  modalProps,
  salvaNovoUsuario,
  editaUsuario,
}) {
  const { usuarioModal, setUsuarioModal } = usuarioModalHook;
  const { values, setValues } = valuesHook;

  const { session } = React.useContext(AppContext);

  return (
    <CommonModal
      title={modalProps ? "Novo usuário" : "Editar usuário"}
      is_open_modal={usuarioModal}
      set_is_open_modal={setUsuarioModal}
      buttons={
        modalProps ? (
          <CommonButton onClick={salvaNovoUsuario} color="success">
            Cadastrar
          </CommonButton>
        ) : (
          <CommonButton onClick={editaUsuario} color="success">
            Salvar
          </CommonButton>
        )
      }
      size="lg"
    >
      <div className="row">
        <div className="col-md-4 pb-3">
          <CommonInput
            label="Nome do usuário"
            id="nome"
            value={values.nome}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md-5 pb-3">
          <CommonInput
            label="E-mail"
            id="email"
            type="email"
            value={values.email}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md-3 pb-3">
          <CommonSelect
            label="Tipo do usuário"
            id="usuarioNivel"
            value={values.usuarioNivel}
            disabled={session.codigo !== "99"}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={[
              { id: "0", text: "Cliente" },
              { id: "99", text: "Administrador" },
            ]}
            placeholder="Selecione o nível do usuário"
          />
        </div>
      </div>
      <div
        className="row align-items-end"
        style={modalProps ? {} : { display: "none" }}
      >
        <div className="col-md-6 pb-3">
          <CommonInputSenha
            label="Senha"
            id="senha"
            value={values.senha}
            placeholder="Digite sua senha"
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required={true}
          />
        </div>
        <div className="col-md-6 pb-3">
          <CommonInputSenha
            label="Confirme a senha"
            id="confirmSenha"
            value={values.confirmSenha}
            placeholder="Digite sua senha"
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required={true}
          />
        </div>
      </div>
    </CommonModal>
  );
}

UsuarioModal.propTypes = {
  usuarioModalHook: PropTypes.shape({
    usuarioModal: PropTypes.bool.isRequired,
    setUsuarioModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  modalProps: PropTypes.bool.isRequired,
  salvaNovoUsuario: PropTypes.func.isRequired,
  editaUsuario: PropTypes.func.isRequired,
};

export default UsuarioModal;
